if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', class CartNotification extends withAnimation(HTMLElement) {
    constructor() {
      super();
      this.wrapper = this.querySelector('.cart-notification-wrapper');
      this.notification = this.querySelector('.cart-notification');
      this.header = document.querySelector('sticky-header');
      this.backDrop = this.querySelector('.modal__backdrop');
      this.closeButtons = this.querySelectorAll('.cart-notification__close');
      this.customCursor = this.querySelector('custom-cursor');

      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.closeButtons.forEach(button => {
        button?.addEventListener('click', this.handleClose.bind(this));
      });
      this.backDrop?.addEventListener('click', this.handleClose.bind(this));
      this.initAnimation({
        duration: parseFloat(this.getAttribute('data-duration')) || 0.25
      });
    }

    async open() {
      await this.closeOtherPopup();
      const isMobile = DeviceUtils.isMobile;
      this.wrapper.classList.add('active');
      document.body.classList.add('overflow-hidden');
      this.customCursor?.disable?.();;
      this.animateShowContent(isMobile);
    }

    close() {
      const isMobile = DeviceUtils.isMobile;
      this.animateHideContent(isMobile);
    }

    onShowActions() {
      this.notification.focus();
      trapFocus(this.notification);
      this.customCursor?.enable?.();
    }

    onCloseActions() {
      document.body.classList.remove('overflow-hidden');
      this.wrapper.classList.remove('active');
      this.customCursor?.disable?.();;
      removeTrapFocus(this.activeElement);
    }

    async animateShowContent(isMobile) {
      const method = isMobile ? 'animateShow' : 'animateSlideIn';
      const options = {
        [isMobile ? 'heightAnimation' : 'slideDirection']: isMobile ? true : 'top',
        backDrop: this.backDrop,
        onComplete: () => this.onShowActions()
      };

      await this[method](this.notification, options);
    }

    async animateHideContent(isMobile) {
      const options = {
        [isMobile ? 'heightAnimation' : 'slideDirection']: isMobile ? true : 'top',
        backDrop: this.backDrop,
        onComplete: () => this.onCloseActions()
      };

      await this.animateHide(this.notification, options);
    }

    async closeOtherPopup() {
      const quickViewModal = document.querySelector('quickview-modal');
      if (quickViewModal.isOpen) {
        await quickViewModal.hide();
      }
    }

    renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section) => {
        const element = document.getElementById(section.id);
        if (element) {
          element.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        }
      });
      this.open();
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        },
        {
          id: 'cart-notification-button',
        },
        {
          id: 'cart-icon-bubble',
        },
        {
          id: 'cart-icon-bubble-footer',
        }
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const target = doc.querySelector(selector);
      return target ? target.innerHTML : '';
    }

    handleClose(event) {
      event.preventDefault();
      this.close();
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    get isOpened() {
      return this.wrapper.classList.contains('active');
    }
  });
}
